import {
  CatIconInfo,
  CatInlineNotification,
  CatButton
} from 'components/blocks-components';
import { format } from 'date-fns/format';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { RequestEquipmentServiceNoEquipmentBannerProps } from '../types';

const RequestEquipmentServiceNotificationBanner = ({
  dealerName,
  contactName,
  submittedDate,
  heading,
  text,
  dismissNotification,
  setDismissNotification
}: Readonly<RequestEquipmentServiceNoEquipmentBannerProps>) => {
  const t = useTranslations();

  const dateFormat = useMemo(() => {
    return submittedDate
      ? `${format(new Date(submittedDate), 'MM/dd/yyyy')}`
      : '';
  }, [submittedDate]);

  const bannerHeading =
    heading ??
    t('SERVICE_REQUESTED_MSG', {
      0: dealerName,
      1: contactName,
      2: dateFormat
    });

  return (
    <div
      className="pb-2 px-3"
      data-testid="request-service-notification-banner"
    >
      <CatInlineNotification
        heading={bannerHeading}
        isDismissed={dismissNotification}
      >
        <CatIconInfo slot="before" />
        <span>{text}</span>
        <CatButton
          variant="ghost"
          slot="after"
          onClick={() => setDismissNotification(true)}
          className="mt-2"
        >
          {t('DISMISS')}
        </CatButton>
      </CatInlineNotification>
    </div>
  );
};

export default RequestEquipmentServiceNotificationBanner;
